import React from 'react';
import langConf from "../js/lang";
import LanguageDropdown from './LanguageDropdown';

class Header extends React.Component {
    state = { language: this.props.language }

    render() {
        let lang = this.props.language;
        let dir = langConf[lang].dir;
        return (
            <div dir={dir} className="col-xl-12" style={{ margin: 'auto', display: 'block' }}>
                <LanguageDropdown language={this.state.language} changeLanguage={this.props.changeLanguage}/>
                <div className="col-xl-3 col-lg-1 col-md-1 col-sm-3 col-0"></div>
                <div className="col-xl-6 col-lg-10 col-md-10 col-sm-6 col-12">
                    <div className="col-xl-12">
                        <a className={`ui logo icon image ${lang}`} href={this.props.currentURL} onClick={this.handleLogoClick}>
                            <img src={"https://www.shelegcrm.com/pirsum/whatshub.png"} alt="logo" style={{ width: '280px' }} />
                        </a>
                        <h3 style={this.props.showHeading ? {textAlign: 'center'} : {display: 'none'}}>{langConf[lang].serviceRegistration}</h3>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-1 col-md-1 col-sm-3 col-0"></div>
            </div>
        );
    }
}

export default Header;